// extracted by mini-css-extract-plugin
export var buttonContent = "_3j-0";
export var centered = "_3j-1";
export var centeredFlex = "_3j-2";
export var errorText = "_3j-3";
export var icon = "_3j-4";
export var iconButtonContent = "_3j-5";
export var monospace = "_3j-6";
export var padded = "_3j-7";